import './App.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/home/Home';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import Login from './components/login/Login';
import Gallery from './components/gallery/Gallery';
import Notice from './components/notice/Notice';
import Contact from './components/admission/contact';
import Certificate from './components/certificate/Certificate';
import Successfull from './components/successful/successful';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ImageModal from './components/modal/poster';



function App() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowModal(true);
    }, 1000); // Show modal after 1 second
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <ScrollToTop />

        {/* ✅ Image Modal on Load */}
        {/* <ImageModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          imageSrc="assets/welcome_popup.webp" // Update the image path as needed
        /> */}

        <Routes>
          <Route index element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="notice" element={<Notice />} />
          <Route path="login" element={<Login />} />
          <Route path="certification" element={<Certificate />} />
          <Route path="thank-you" element={<Successfull />} />
          <Route path='*' element={<Home />} />
        </Routes>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
